var _defs, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBulgaria = function SvgBulgaria(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bulgaria_svg__a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Bulgaria_svg__b"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Bulgaria_svg__i",
    cx: -120,
    cy: 99.1,
    r: 97.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Bulgaria_svg__c"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Bulgaria_svg__i",
    cx: 99.5,
    cy: 99.9,
    r: 97.7,
    transform: "rotate(-45 99.478 99.895)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Bulgaria_svg__d"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Bulgaria_svg__i",
    cx: 319.4,
    cy: 100.3,
    r: 97.4,
    transform: "rotate(-80.8 319.305 100.345)"
  })), /*#__PURE__*/React.createElement("style", null, ".Bulgaria_svg__i,.Bulgaria_svg__q{stroke-width:0}.Bulgaria_svg__i{fill:none}.Bulgaria_svg__q{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#Bulgaria_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3663af",
      strokeWidth: 0
    },
    d: "M-265.9 2H25.9v194.5h-291.8z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Bulgaria_svg__q",
    d: "M-265.9 2H25.9v129.7h-291.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ed1c24",
      strokeWidth: 0
    },
    d: "M-265.9 2H25.9v64.9h-291.8z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.9,
    r: 97.7,
    style: {
      stroke: "#a5a7aa",
      strokeMiterlimit: 10,
      strokeWidth: "1.8px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#Bulgaria_svg__c)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Bulgaria_svg__q",
    d: "M-47.1 2h293v195.4h-293z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00b174",
      strokeWidth: 0
    },
    d: "M-47.1 67.2h293v130.2h-293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ef3d23",
      strokeWidth: 0
    },
    d: "M-47.1 132.3h293v65.1h-293z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Bulgaria_svg__i",
    cx: 99.5,
    cy: 99.9,
    r: 97.7,
    transform: "rotate(-45 99.478 99.895)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#Bulgaria_svg__d)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bulgaria_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090b0a",
      strokeWidth: 0
    },
    d: "M173.3 3.1h292.2v194.8H173.3z",
    id: "Bulgaria_svg__f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Bulgaria_svg__g",
    style: {
      fill: "#ed2224",
      strokeWidth: 0
    },
    d: "M173.3 68h292.2v129.9H173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bulgaria_svg__h",
    style: {
      fill: "#fedc00",
      strokeWidth: 0
    },
    d: "M173.3 132.9h292.2v64.9H173.3z"
  })));
};
export default SvgBulgaria;